import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './styles/index.scss';
import Navigation from './views/navigation';

class App extends Component {
  render() {
    return (
      <div>
        <Navigation />
      </div>
    );
  }
}

export default App;
